import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ILoggedInUser } from "../../interfaces/common/loggedInUser";
import { LoggedInUserService } from "../../services/common/logged-in-user.service";
import { SearchParameters } from "../../shared/models/searchParameters.model";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { EmployeeBankAccountService } from "../services/employee-bank-account.service";
import { PagedResult } from "../../shared/models/pagedResult.model";
import { ManageEmployeeBankAccountComponent } from "./manage-employee-bank-account/manage-employee-bank-account.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "employee-bank-account",
  templateUrl: "./employee-bank-account.component.html",  
  standalone: true,  
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatPaginatorModule, ReactiveFormsModule],
})
export class EmployeeBankAccountComponent {
  title = "EmployeeBankAccountComponent";
  isLoading: boolean = false;
  dataSource: MatTableDataSource<EmployeeBankAccountModel>;
  user: ILoggedInUser;
  isUserAuthorized: boolean;
  displayedColumns: string[] = ['number', 'employee', 'account', 'dateVerified'];
  searchDone: boolean = false;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  searchForm: FormGroup;
  pagedData: PagedResult<EmployeeBankAccountModel[]>;
  searchRequestParams: SearchParameters<EmployeeBankAccountModel>

  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private employeeBankAccountService: EmployeeBankAccountService,    
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      employeeName: new FormControl(''),
      account: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isUserAuthorized = this.user.adminRight;
      }      
    });
  }

  search() {
    if(this.isUserAuthorized){
      this.isLoading = true;
      this.employeeBankAccountService.searchBankAccounts(this.searchRequestParams)
        .subscribe(data => {        
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<EmployeeBankAccountModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<EmployeeBankAccountModel>([]);
    }
  }  

  submitForm(): void {
    this.searchRequestParams = {
      query: {
        employeeName: this.searchForm.get('employeeName').value,
        account: this.searchForm.get('account').value,
        employeeNo: 0,
        dateVerified: undefined,
        cardNumber: undefined
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };
    
    this.search();
  }
  
  openDialog(employeeNo: number): void {
    if(this.isUserAuthorized){
      this.dialog.open(ManageEmployeeBankAccountComponent,{
        data: employeeNo
      });

      this.dialog.afterAllClosed.subscribe(() => {
        this.submitForm();
      });
    }
    
  }

  public pageChangeEvent(event?:PageEvent){
    this.searchRequestParams.pageIndex = event.pageIndex;
    this.searchRequestParams.pageSize = event.pageSize;
    this.search();
  }  
}
